module.exports = __webpack_public_path__ + "media/american-violence.5e574980.mp4";